import { createFeatureSelector } from '@ngrx/store';
import { ToastMessage } from '@ajgre/toolkit';
import { TOAST_FEATURE_KEY } from '@cmi/store/toast';

export const selectToastMessages = createFeatureSelector<ToastMessage[]>(TOAST_FEATURE_KEY);
